import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../shared/hooks";
import useRolePermissions from "../shared/hooks/useRolePermissions";
import { REGION_ROUTE, ROLES_CONTENT_PROPS, ROLES_ROUTE } from "../shared/constants/constant-data";


interface ProtectedRouteProps {
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { hasPermissions } = useRolePermissions();

  const routePermissionsMap: Record<string, any> = {
    "/on-premises/newscan": ROLES_ROUTE.NEW_SCAN,
    "/on-premises/new-newscan": ROLES_ROUTE.NEW_SCAN,
    "/on-premises/scans-1": ROLES_ROUTE.MYSCANS,
    "/on-premises/scans": ROLES_ROUTE.MYSCANS,
    "/on-premises/assets": ROLES_ROUTE.DEVICE_MGNT,
    "/on-premises/security-posture": ROLES_ROUTE.SECURITY_INFO,
    "/on-premises/acceptedrisk": ROLES_ROUTE.ACCEPTED_RISK,
    "/on-premises/credentials": ROLES_CONTENT_PROPS.VIEW_CREDENTIALS,
    "/organization/agent": ROLES_CONTENT_PROPS.VIEW_AGENT,
    "/organization/vpn": ROLES_CONTENT_PROPS.VIEW_VPN,
    "/organization/custom-ports": ROLES_CONTENT_PROPS.VIEW_CREDENTIALS,
    "/organization/user-management": ROLES_ROUTE.USER_MGNT,
    "/organization/roles": ROLES_ROUTE.ROLE_MGNT,
    "/on-premises/scan-details": ROLES_CONTENT_PROPS.SCAN_DETAILS,
    "/on-premises/discovery-security": ROLES_CONTENT_PROPS.SCAN_DETAILS,
    "/on-premises/asset_v2": ROLES_ROUTE.DEVICE_MGNT,
    "/organization/regions": [
      ROLES_ROUTE.REGION_MGNT,
      REGION_ROUTE.MODIFY_REGION_DATA,
      REGION_ROUTE.MODIFY_REGION_LEVEL,
    ],
  };

  const location = useLocation();
  const path = location.pathname;

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  const requiredPermissions = routePermissionsMap[path];
  const hasRequiredPermission = Array.isArray(requiredPermissions)
    ? requiredPermissions.some(hasPermissions)
    : hasPermissions(requiredPermissions);

  if (requiredPermissions && !hasRequiredPermission) {
    console.log(`ProtectedRoute: User does not have permission for ${path}`);
    return <Navigate to="/unauthorized" replace />;
  }
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;

